import { useRouter, NextRouter } from 'next/router'
import { useModuleContext } from './Context'

function useSortOptions() {
  const router: NextRouter = useRouter()
  const {
    state: { CMSProps }
  } = useModuleContext()

  // We make sure it's ALWAYS a string
  const orderBy: string = router.query.orderBy?.toString() || ''
  const currentOrderBy: string = orderBy || 'show|desc|showFullName'

  let options = [
    { key: 0, label: CMSProps.gpv_grp1_random_sort_label, value: 'random|desc|' },
    { key: 1, label: CMSProps.gpv_grp1_artist_sort_label, value: 'artist|asc|artistName' },
    { key: 2, label: CMSProps.gpv_grp1_show_sort_label, value: 'show|desc|showFullName' },
    { key: 3, label: CMSProps.gpv_grp1_title_sort_label, value: 'title|asc|' },
    { key: 4, label: CMSProps.gpv_grp1_year_asc_sort_label, value: 'year|asc|' },
    { key: 5, label: CMSProps.gpv_grp1_year_desc_sort_label, value: 'year|desc|' }
  ]

  return { options, currentOrderBy }
}

export default useSortOptions